
import Msg from 'vux/src/components/msg/index.vue'

import { inspectOrder } from "@/model/trader/orderService";
import UserInfoToast from "@/components/toast/userInfo";
import Txrweb from '@/utils/mixin/mixinTxrweb'

export default {
mixins: [Txrweb],
data() {
return {
title:'操作成功!',
statusFlag:false,
}
},
components: {
Msg,
UserInfoToast
},
computed: {
templateFlag() {
return this.$route.query.templateFlag || "";
},
uuid() {
return this.$route.query.uuid || "";
},
outTrade(){
return this.$route.query.outTrade || "";

}
},
beforeDestroy() {
window.clearInterval(this.timer);
window.clearInterval(this.timeDelayer);
this.$loading.hide()
/** 离开组件时，强制结束录制 */



},

mounted () {

this.querySetTX()

this.orderState()
},
methods: {

orderState() {

if(!this.uuid){
this.STATISTICS_CONFIG.insur_pay_success_page();
this.statusFlag = true;
this.operatingTX()
return false;
}
this.$loading.show()

this.timeDelayer = setTimeout(() => {
this.$loading.hide()
this.$router.replace({
path: "/payResult",
query: this.$route.query,
});
}, 10000);


this.timer = setInterval(() => {


const out_trade_no = this.uuid
if(this.templateFlag == 'coupon'){
out_trade_no = this.outTrade
}
inspectOrder(this.templateFlag, out_trade_no).then((data) => {
if (data.is_paid != 0) { //是否支付
this.statusFlag = true;

window.clearInterval(this.timer);
window.clearTimeout(this.timeDelayer);
this.$loading.hide()
this.STATISTICS_CONFIG.insur_pay_success_page();
this.operatingTX()
this.$nextTick(()=>{
if (this.stopTX) {
this.stopTX()
}
})

}
}).catch((err) => {
window.clearInterval(this.timer);
window.clearTimeout(this.timeDelayer);
this.$loading.hide()
if (err.code == "50") { //未登录
if (this.CHANNAL_ID == "APP") {
window.location.href = process.env.VUE_APP_HREF + encodeURIComponent(`${window.location.origin}/personal`);
} else {
this.STATISTICS("load", "sybao_ins_renewed_page");
this.$refs.showLogin.showoast();
}
}
})
}, 1000);
},
},
}
